import React from 'react';
import { SuggestEditModal } from '~/components/Patient/Referrals';
import { ServicesContext } from '~/services';
import { ProviderType, getProviderInfo } from '~/util/providerUtils';

export interface ReferralDisabledAlertProps {
    provider: ProviderType;
    setSuggestedEdit: (x: boolean) => void;
}

export function ReferralDisabledAlert({ provider, setSuggestedEdit }: ReferralDisabledAlertProps) {
    const context = React.useContext(ServicesContext);
    const { providerFax, providerIsContact } = getProviderInfo(provider);
    const contactMissingFax = providerIsContact && !providerFax;

    if (
        !(
            context.user.hasFeatureToggle('send_referral') &&
            context.user.getExternalAccount('Core App') &&
            contactMissingFax
        )
    )
        return null;

    return (
        <div className="permissions-alert permissions-alert-card">
            {context.user.hasFeatureToggle('suggested_edits') ? (
                <div>
                    Unable to send referral from Zephyr due to missing fax number for provider.{' '}
                    <SuggestEditModal provider={provider} setSuggestedEdit={setSuggestedEdit} /> for
                    this provider.
                </div>
            ) : (
                <div>
                    Unable to send referral via Zephyr due to missing fax for provider. Contact{' '}
                    <a href="mailto: PortalSupport@WellMed.net">PortalSupport@WellMed.net</a> to add
                    fax number.
                </div>
            )}
        </div>
    );
}
